import { useState } from "react";
import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { copyText } from "@/lib/qr";
import { toast } from "sonner";

export function CodeReveal({ code, onDone }) {
  const [saved, setSaved] = useState(false);
  return (
    <div className="space-y-4" data-testid="master-code-reveal">
      <h1 className="text-xl font-bold">Seu código de acesso</h1>
      <p className="text-sm text-muted-foreground">Ele aparece <b>só desta vez</b>. Anote ou guarde em local seguro: ele é a sua senha para entrar no Admin Master.</p>
      <div className="rounded-xl border-2 border-dashed border-primary/50 bg-primary/5 p-4 text-center font-mono text-3xl font-bold tracking-[0.2em]" data-testid="master-code-value">
        {code.replace(/(\d{5})(\d{5})/, "$1 $2")}
      </div>
      <Button variant="outline" className="w-full" onClick={async () => { await copyText(code); toast.success("Código copiado"); }} data-testid="master-code-copy">
        <Copy className="h-4 w-4 mr-1" />Copiar código
      </Button>
      <label className="flex items-center gap-2 text-sm">
        <Checkbox checked={saved} onCheckedChange={(v) => setSaved(!!v)} data-testid="master-code-saved-check" />Já salvei o código em local seguro
      </label>
      <Button className="w-full h-11" disabled={!saved} onClick={onDone} data-testid="master-code-continue">Continuar</Button>
    </div>
  );
}

export function CodeRevealDialog({ code, onClose }) {
  return (
    <Dialog open={!!code} onOpenChange={() => {}}>
      <DialogContent className="max-w-sm" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="master-code-dialog">
        {code && <CodeReveal code={code} onDone={onClose} />}
      </DialogContent>
    </Dialog>
  );
}
